import { render } from "./ProjectPreview.vue?vue&type=template&id=07b53540"
import script from "./ProjectPreview.vue?vue&type=script&lang=js"
export * from "./ProjectPreview.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__